module.exports = __webpack_public_path__ + "img/alinhamento.c88781a3.svg";